import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { TInnerCardProps } from '../../types/productSeriesDetailFeature.types';
import CTAButton, { ctaEnums } from '../../../@shared/ctaButton';
import CTAWithArrow from '../../../@shared/ctaWithArrow';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import Picture from '../../../@shared/picture';
import VideoPlayer from '../../../@shared/videoPlayer';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import { InnerCardModel } from '../../models/innerCard.model';
import { appendRootToRichTextInternalLinks } from '../../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendRootToInternalLink } from '../../../../utils/appendRootToInternalLink.utils';

const InnerCard: FC<TInnerCardProps> = (props) => {
  const model = new InnerCardModel(props);

  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);

  return (
    <section className="inner-cards-module">
      {model.bannerType === 'video' && model.videoUrl ? (
        <div className="inner-cards-module--wrapper">
          <VideoPlayer
            link={model.videoUrl}
            autoPlay={true}
            showThumbnail={model.showThumbnail}
            editorialImageProps={model.editorialImageProps}
          />
        </div>
      ) : (
        model.firstAsset && (
          <Picture
            productImageProps={{
              ...model.pictureProps,
              pictureClassName: 'inner-cards-module__picture--fixed-aspect-ratio',
            }}
          />
        )
      )}

      {model?.title && <RichText tag="h2" field={{ value: model?.title }} className="inner-cards-module__title rich-text"></RichText>}
      {model?.description && (
        <RichText
          editable={false}
          field={{ value: appendRootToRichTextInternalLinks(model?.description) }}
          tag="div"
          className="inner-cards-module__description rich-text"
        />
      )}
      <div className="inner-cards-module__ctas">
        {(model?.button1?.url || model?.button1?.label) && (
          <CTAButton type={ctaEnums.primaryRed}>
            <RoutableNotEditableLink
              className="inner-cards-module__primary-link"
              href={appendRootToInternalLink(model?.button1?.url)}
              target={targetLinkdsk({ value: { href: model?.button1?.url, target: model?.button1?.target } }, isDesktop)}
            >
              {model?.button1?.label}
            </RoutableNotEditableLink>
          </CTAButton>
        )}
        {(model?.button2?.url || model?.button2?.label) && (
          <CTAWithArrow
            href={appendRootToInternalLink(model?.button2?.url) || ''}
            target={targetLinkdsk({ value: { href: model?.button2?.url, target: model?.button2?.target } }, isDesktop)}
            text={model?.button2?.label}
          />
        )}
      </div>
    </section>
  );
};

export default InnerCard;
